<template>
  <base-page-layout
    v-show="!loadingPage"
    ref="base-page"
    :title="$t('campanhas.resultados_campanha')"
    :hide-breadcrumbs="$getFirstValue()"
    use-new-filters
    clear-filter-on-init
    :filters="['lojas']"
    hide-ecommerce-configuration
    :filter-to-units="campaignUnitIds"
    check-all-units-on-init
  >
    <mf-loading-dialog :loading="loadingPage">
      <div v-if="metrics.clients_metrics">
        <v-row v-if="campaign.title">
          <v-col class="pl-4" cols="3">
            <span class="section-title">{{ campaign.title }}</span>
            <p class="campaign-description mt-3">
              {{ campaign.description }}
            </p>

            <p class="status d-flex align-center">
              <mf-icon fill small :color="getStatusLabel(campaign.status).color"> fiber_manual_record </mf-icon
              ><span class="label-status">{{ getStatusLabel(campaign.status).text }}</span>
            </p>
          </v-col>

          <v-col cols="9">
            <v-row class="px-4">
              <v-card class="px-4" width="100%">
                <v-card-text>
                  <v-row>
                    <v-col cols="6">
                      <v-row class="py-0">
                        <v-col class="py-0">
                          <h3 class="info-header">Periodo de mensuração</h3>
                          <p v-if="campaign.initial_date && campaign.final_date" class="info-description">
                            {{ getPeriod(campaign.initial_date, campaign.final_date) }}
                          </p>
                        </v-col>
                      </v-row>
                      <v-row class="py-0">
                        <v-col class="py-0" cols="12">
                          <h3 class="info-header">Configurações avançadas</h3>
                        </v-col>
                        <v-col class="py-0" cols="12">
                          <mf-toggle v-model="campaign.advanced_configuration.multiple_channels_per_consumer" dense disabled class="ml-1 pt-0" hide-details>
                            <template v-slot:label>
                              <span class="info-description"> Permitir mais de um canal por consumidor </span>
                            </template>
                          </mf-toggle>
                        </v-col>
                        <v-col class="py-0" cols="12">
                          <mf-toggle v-model="campaign.advanced_configuration.multiple_messages_per_consumer" dense disabled class="ml-1 pt-0" hide-details>
                            <template v-slot:label>
                              <span class="info-description"> Redisparar para consumidores durante o período da campanha </span>
                            </template>
                          </mf-toggle>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <h3 class="info-header">Para os clientes</h3>

                      <div v-if="campaign.segments.length">
                        <strong class="font-weight-bold info-description">Dos segmentos</strong>
                        <v-chip-group :column="showAllSegments" show-arrows active-class="primary--text">
                          <v-chip v-for="(segment, index) in campaign.segments" :key="index" small :ripple="false">
                            <span>{{ segment.name }}</span>
                          </v-chip>
                        </v-chip-group>
                        <a v-if="campaign.segments.length > 1" class="user-select-none mt-3 mb-2 body-2 btn-link" @click="showAllSegments = !showAllSegments">{{
                          showAllSegments ? 'Mostrar menos' : 'Mostrar mais'
                        }}</a>
                        <!-- <strong class="font-weight-bold info-description">Com o perfil</strong>
                        <v-row class="pl-2">
                          <v-col class="pa-1" cols="6">
                            <span class="info-description">{{ floatToPercentString(campaign.product_targets.upsell) }} upsell</span>
                          </v-col>
                          <v-col class="pa-1" cols="6">
                            <span class="info-description">{{ floatToPercentString(campaign.product_targets.repurchase) }} recompra</span>
                          </v-col>
                        </v-row> -->
                      </div>

                      <div v-else>
                        <span class="info-description">Escolhidos pela IA, seguindo os critérios:</span>
                        <v-row class="pl-2">
                          <v-col v-for="item in clientsDistributionByIA" :key="item.label" class="pa-1" cols="6">
                            <span class="info-description">{{ item.value }} {{ item.label }}</span>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="campaign.units">
                    <v-col cols="12">
                      <h3 class="info-header">{{ campaign.units.length }} {{ campaign.units.length > 1 ? 'Lojas' : 'Loja' }}</h3>
                      <div>
                        <v-chip-group :column="showAllUnits" show-arrows active-class="primary--text">
                          <v-chip v-for="(segment, index) in campaign.units" :key="index" small :ripple="false">
                            <span>{{ segment.name }}</span>
                          </v-chip>
                        </v-chip-group>
                        <a v-if="campaign.units.length > 1" class="user-select-none mt-3 mb-0 body-2 btn-link" @click="showAllUnits = !showAllUnits">{{
                          showAllUnits ? 'Mostrar menos' : 'Mostrar mais'
                        }}</a>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="campaign.offer_sales && campaign.offer_sales.length > 0">
                    <v-col cols="12">
                      <h3 class="info-header">{{ campaign.offer_sales.length }} {{ campaign.offer_sales.length > 1 ? 'Produtos' : 'Produto' }}</h3>
                      <div>
                        <v-chip-group :column="showAllProducts" show-arrows active-class="primary--text">
                          <v-chip v-for="(segment, index) in campaign.offer_sales" :key="index" small :ripple="false">
                            <span>{{ segment.sku }} - {{ segment.name }}</span>
                          </v-chip>
                        </v-chip-group>
                        <a
                          v-if="campaign.offer_sales.length > 1"
                          class="user-select-none mt-3 mb-0 body-2 btn-link"
                          @click="showAllProducts = !showAllProducts"
                          >{{ showAllProducts ? 'Mostrar menos' : 'Mostrar mais' }}</a
                        >
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="campaign.takepay_offer_sales && campaign.takepay_offer_sales.length">
                    <v-col cols="12">
                      <h3 class="info-header">
                        {{ campaign.takepay_offer_sales.length }} {{ campaign.takepay_offer_sales.length > 1 ? 'Produtos' : 'Produto' }}
                      </h3>
                      <div>
                        <v-chip-group :column="showAllProducts" show-arrows active-class="primary--text">
                          <v-chip v-for="(segment, index) in campaign.takepay_offer_sales" :key="index" small :ripple="false">
                            <span>{{ segment.sku }} - {{ segment.name }}</span>
                          </v-chip>
                        </v-chip-group>
                        <a
                          v-if="campaign.takepay_offer_sales.length > 1"
                          class="user-select-none mt-3 mb-0 body-2 btn-link"
                          @click="showAllProducts = !showAllProducts"
                          >{{ showAllProducts ? 'Mostrar menos' : 'Mostrar mais' }}</a
                        >
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="campaign.percentage_offer_sales && campaign.percentage_offer_sales.length">
                    <v-col cols="12">
                      <h3 class="info-header">
                        {{ campaign.percentage_offer_sales.length }} {{ campaign.percentage_offer_sales.length > 1 ? 'Produtos' : 'Produto' }}
                      </h3>
                      <div>
                        <v-chip-group :column="showAllProducts" show-arrows active-class="primary--text">
                          <v-chip v-for="(segment, index) in campaign.percentage_offer_sales" :key="index" small :ripple="false">
                            <span>{{ segment.sku }} - {{ segment.name }}</span>
                          </v-chip>
                        </v-chip-group>
                        <a
                          v-if="campaign.percentage_offer_sales.length > 1"
                          class="user-select-none mt-3 mb-0 body-2 btn-link"
                          @click="showAllProducts = !showAllProducts"
                          >{{ showAllProducts ? 'Mostrar menos' : 'Mostrar mais' }}</a
                        >
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="campaign.combo_offer_sales && campaign.combo_offer_sales.length">
                    <v-col cols="12">
                      <h3 class="info-header">{{ campaign.combo_offer_sales.length }} {{ campaign.combo_offer_sales.length > 1 ? 'Produtos' : 'Produto' }}</h3>
                      <div>
                        <v-chip-group :column="showAllProducts" show-arrows active-class="primary--text">
                          <v-chip v-for="(segment, index) in campaign.combo_offer_sales" :key="index" small :ripple="false">
                            <span>{{ segment.sku }} - {{ segment.name }}</span>
                          </v-chip>
                        </v-chip-group>
                        <a
                          v-if="campaign.combo_offer_sales.length > 1"
                          class="user-select-none mt-3 mb-0 body-2 btn-link"
                          @click="showAllProducts = !showAllProducts"
                          >{{ showAllProducts ? 'Mostrar menos' : 'Mostrar mais' }}</a
                        >
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pl-4">
            <span class="section-title">Resultados gerais</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col v-for="(card, index) in dataCards" :key="index" cols="3">
            <cbm-card
              :number-text="card.value"
              :title="card.text"
              :tooltip="card.helpText"
              :boolean-loader="loadingMetrics"
              :quick-action="card.quickAction"
              :is-currency="card.isCurrency"
              :percent-text="card.underText"
              :percent-description="card.description"
              unset-percentage-colors
              simple-card
            />
          </v-col>
          <v-col cols="12">
            <customers-types-funnel-graph
              :campaign="campaign"
              :metrics="metrics"
              :loading="loadingFilter"
              :date-criteria-filter="dateCriteriaFilter"
              :channels="stateFilters.channels"
              :units="stateFilters.units"
              :units-configuration="stateFilters.unitsConfiguration"
            />
          </v-col>
        </v-row>

        <v-row class="mt-n4">
          <v-col class="pl-4">
            <span class="section-title"
              >Clientes que
              <span class="select-label">
                <v-select
                  v-model="chosenCustomerType"
                  color="marca-0-l40"
                  :items="customersTypes"
                  hide-details
                  item-color="marca-0-l40"
                  item-value="val"
                  item-text="text"
                >
                </v-select> </span
            ></span>
          </v-col>
        </v-row>

        <v-row align-content="stretch">
          <v-col cols="8">
            <gender-and-age-metrics-chart :data-chart="ticketByGenderAndAge" :chosen-customer-type="chosenCustomerType" :loading="loadingFilter" />
          </v-col>

          <v-col cols="4">
            <status-card
              :data-chart="metrics.clients_metrics"
              :chosen-customer-type="chosenCustomerType"
              :loading="loadingFilter"
              :campaign="campaign"
              :date-criteria-filter="dateCriteriaFilter"
              :units="stateFilters.units"
              :units-configuration="stateFilters.unitsConfiguration"
              :version="version"
            />
          </v-col>

          <v-col cols="7">
            <customer-billing-triggers
              :campaign="campaign"
              :metrics="metrics"
              :loading="loadingFilter"
              :chosen-customer-type="chosenCustomerType"
              :date-criteria-filter="dateCriteriaFilter"
              :channels="stateFilters.channels"
              :units="stateFilters.units"
              :units-configuration="stateFilters.unitsConfiguration"
            />
          </v-col>

          <v-col cols="5">
            <receive-channel-chart
              :data-chart="metrics.general_metrics"
              :campaign="campaign"
              :chosen-customer-type="chosenCustomerType"
              :loading="loadingFilter"
            />
          </v-col>

          <v-col cols="12">
            <time-biggest-purchase-chart
              :data-chart="ticketsByHour"
              :chosen-customer-type="chosenCustomerType"
              :loading="loadingFilter"
              metrics-period="YEARLY"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pl-4">
            <span class="section-title">Resultados por produtos</span>
          </v-col>
        </v-row>

        <v-card class="mt-3">
          <product-billing-history
            :campaign="campaign"
            :units="stateFilters.units"
            :loading="loadingFilter"
            :units-configuration="stateFilters.unitsConfiguration"
          />
        </v-card>

        <results-by-products
          :metrics="metrics.products_metrics"
          :loading="loadingFilter"
          :campaign="campaign"
          :date-criteria-filter="dateCriteriaFilter"
          :units="stateFilters.units"
          :units-configuration="stateFilters.unitsConfiguration"
          :campaign-channels="campaign.channels"
        />

        <v-row class="mt-3">
          <v-col cols="7">
            <v-card>
              <related-products :data-chart="metrics.products_metrics" :loading="loadingFilter" />
            </v-card>
          </v-col>

          <v-col cols="5">
            <v-card>
              <average-basket-items :data-card="itemsBasket" :loading="loadingFilter" />
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pl-4">
            <span class="section-title">Canais</span>
          </v-col>
        </v-row>

        <channel-triggers class="mt-3" :campaign="campaign" :metrics="metrics" :loading="loadingFilter" />

        <mf-action-buttons
          :primary-button="{
            text: 'Duplicar',
            action: cloneOmniCampaign,
            isVisible: true,
            isLoading: loadingCloneCampaign,
          }"
          :cancel-button="{
            text: 'Fechar',
            action: backToOffersList,
            isVisible: true,
            isLoading: loadingCloneCampaign,
          }"
        />
      </div>
    </mf-loading-dialog>
  </base-page-layout>
</template>

<script>
import Swal from 'sweetalert2'
import { DateTime } from 'luxon'
import { mapMutations, mapState } from 'vuex'

import {
  QUERY_GET_OMNI_CAMPAIGN,
  QUERY_GET_OMNI_CAMPAIGN_TICKETS_BY_HOURS,
  QUERY_GET_OMNI_CAMPAIGN_CHANNELS_ITEMS,
  QUERY_GET_OMNI_CAMPAIGN_TICKETS_BY_GENDER_AND_AGE,
  QUERY_METRICS_OMNI_CAMPAIGN_BY_UNITS,
  QUERY_CLONE_OMNI_CAMPAIGN,
} from '@/modules/maria/campanha-da-maria/graphql'
import BasePageLayout from '@/components/BasePageLayout.vue'
import { criteriaGroup, campaignReceivedAndPurchasedAtUnitsOnFixedPeriodCriteria } from '@/components/quick-actions/segmentationGroups.js'
import { localeString, getStatusLabel, getPeriod, floatToPercentString, putEmptyValue, assertArray } from '@/config/helpers.js'
import { mergeAllComboProducts } from '@/modules/campanhas/gestao-ofertas-v2/helpers/products.js'

export default {
  name: 'Results',
  components: {
    BasePageLayout,
    CbmCard: () => import('@/components/CbmCard.vue'),
    StatusCard: () => import('@/modules/maria/campanha-da-maria/views/components/StatusCard.vue'),
    RelatedProducts: () => import('@/modules/maria/campanha-da-maria/views/components/RelatedProducts.vue'),
    ChannelTriggers: () => import('@/modules/maria/campanha-da-maria/views/components/ChannelTriggers.vue'),
    ResultsByProducts: () => import('@/modules/maria/campanha-da-maria/views/components/ResultsByProducts.vue'),
    AverageBasketItems: () => import('@/modules/maria/campanha-da-maria/views/components/AverageBasketItems.vue'),
    ReceiveChannelChart: () => import('@/modules/maria/campanha-da-maria/views/components/ReceiveChannelChart.vue'),
    ProductBillingHistory: () => import('@/modules/maria/campanha-da-maria/views/components/ProductBillingHistory.vue'),
    CustomerBillingTriggers: () => import('@/modules/maria/campanha-da-maria/views/components/CustomerBillingTriggers.vue'),
    GenderAndAgeMetricsChart: () => import('@/modules/maria/campanha-da-maria/views/components/GenderAndAgeMetricsChart.vue'),
    TimeBiggestPurchaseChart: () => import('@/modules/maria/campanha-da-maria/views/components/TimeBiggestPurchaseChart.vue'),
    CustomersTypesFunnelGraph: () => import('@/modules/maria/campanha-da-maria/views/components/CustomersTypesFunnelGraph.vue'),
  },
  data: () => ({
    version: 1,
    loadingCloneCampaign: false,
    metrics: {},
    customersTypes: [
      {
        text: 'receberam e compraram',
        val: 'received_and_bought',
      },
      {
        text: 'receberam e compraram produtos da campanha',
        val: 'received_with_products',
      },
      {
        text: 'receberam e compraram apenas produtos da campanha',
        val: 'received_with_only_products',
      },
    ],
    itemsBasket: [],
    chosenCustomerType: 'received_and_bought',
    ticketByGenderAndAge: [],
    ticketsByHour: [],
    locale: localeString,
    DateTime: DateTime,
    showAllProducts: false,
    showAllUnits: false,
    showAllSegments: false,
    campaign: {},
    loadingPage: false,
    loadingFilter: false,
  }),
  computed: {
    ...mapState({
      stateUnits: (state) => state.units,
      stateFilters: (state) => state.filters,
    }),
    clientsDistributionByIA() {
      if (this.campaign.version === 2) {
        const { actives, at_risk, losses, never_bought, recent_inactives } = this.campaign.client_targets_distribution
        return [
          {
            label: 'ativos',
            value: this.floatToPercentString(actives),
          },
          {
            label: 'inativos recentes',
            value: this.floatToPercentString(recent_inactives),
          },
          {
            label: 'risco de perder',
            value: this.floatToPercentString(at_risk),
          },
          {
            label: 'perdidos',
            value: this.floatToPercentString(losses),
          },
          {
            label: 'nunca compraram',
            value: this.floatToPercentString(never_bought),
          },
        ]
      }
      const { active, inactive, lost, never_bought } = this.campaign.client_targets
      return [
        {
          label: 'ativos',
          value: this.floatToPercentString(active),
        },
        {
          label: 'inativos',
          value: this.floatToPercentString(inactive),
        },
        {
          label: 'perdidos',
          value: this.floatToPercentString(lost),
        },
        {
          label: 'nunca compraram',
          value: this.floatToPercentString(never_bought),
        },
      ]
    },
    campaignUnitIds() {
      if (!this.campaign?.units?.length) {
        return []
      }
      return this.campaign.units.map((unit) => unit.id_erp)
    },
    dateCriteriaFilter() {
      const formattedInitialDate = DateTime.fromFormat(this.campaign.initial_date, 'yyyy-MM-dd').toFormat('yyyyMMdd')
      const formattedFinalDate = DateTime.fromFormat(this.campaign.final_date, 'yyyy-MM-dd').toFormat('yyyyMMdd')
      const formattedADayBeforeCampaignStart = DateTime.fromFormat(this.campaign.initial_date, 'yyyy-MM-dd').plus({ day: -1 }).toFormat('yyyyMMdd')

      return { formattedInitialDate, formattedFinalDate, formattedADayBeforeCampaignStart }
    },
    dataCards() {
      return [
        {
          value: localeString(this.metrics.clients_metrics.general.received_and_bought.count || 0),
          text: 'Clientes que compraram',
          underText: `${localeString(
            parseFloat((this.metrics.clients_metrics.general.received_and_bought.count / this.metrics.clients_metrics.general.received.count) * 100) || 0,
            1
          )}%`,
          description: `dos ${this.metrics.clients_metrics.general.received.count.toLocaleString('pt-BR')} clientes que receberam`,
          helpText: 'Quantidade de clientes que receberam algum disparo e realizaram pelo menos uma compra no período da campanha nas lojas selecionadas',
          quickAction: {
            id: 'received_and_purchased_any_campaign_maria_campaign',
            shortDescription: `Clientes que receberam campanhas e compraram`,
            longDescription: `Clientes que compraram na campanha ${this.campaign.title}`,
            segmentationGroup: criteriaGroup(
              campaignReceivedAndPurchasedAtUnitsOnFixedPeriodCriteria(
                [this.campaign._id],
                this.dateCriteriaFilter.formattedInitialDate,
                this.dateCriteriaFilter.formattedFinalDate,
                this.stateFilters.unitsConfiguration
              )
            ),
          },
        },
        {
          value: localeString(this.metrics.clients_metrics.general.received_and_bought.average_ticket || 0, 0),
          text: 'Ticket médio',
          isCurrency: true,
          underText: `${localeString(
            this.metrics.analytic_metrics.general.average_ticket_received_variation > 0
              ? this.metrics.analytic_metrics.general.average_ticket_received_variation
              : this.metrics.analytic_metrics.general.average_ticket_received_variation < 0
              ? this.metrics.analytic_metrics.general.average_ticket_received_variation * -1
              : 0,
            1
          )}%`,
          description: `a ${this.metrics.analytic_metrics.general.average_ticket_received_variation > 0 ? 'mais' : 'menos'} que quem não recebeu`,
          helpText:
            'Ticket médio dos clientes que receberam a campanha e realizaram pelo menos uma compra no período de mensuração em comparação com o ticket médio dos consumidores do clube no mesmo período dessa campanha',
        },
        {
          value: localeString(this.metrics.clients_metrics.general.received_and_bought.revenue || 0, 0),
          text: 'Faturamento',
          isCurrency: true,
          isInteger: true,
          underText: `${localeString(
            parseFloat((this.metrics.clients_metrics.general.received_and_bought.revenue / this.metrics.clients_metrics.general.total.revenue) * 100),
            1
          )}%`,
          description: 'de faturamento total',
          helpText:
            'Faturamento dos clientes que receberam e compraram em comparação com o faturamento dos consumidores do clube no mesmo período dessa campanha',
        },
        {
          value: localeString(this.valueLeverage || 0),
          text: 'Alavancagem',
          underText: this.underTextValueLeverage,
          description: this.textLeverage,
          helpText: 'Faturamento total gerado para cada real investido na campanha. Considera apenas o faturamento gerado pelos canais com custo unitário',
        },
      ]
    },
    isCostChannels() {
      return !Object.keys(this.campaign.channels || {})
        .slice(0, 4)
        .filter((channel) => this.campaign.channels[channel])
        .every((channel) => ['whatsapp', 'push'].includes(channel))
    },
    valueLeverage() {
      return this.isCostChannels ? this.metrics.analytic_metrics.general.received_roi : '-'
    },
    textLeverage() {
      return this.isCostChannels ? `Investimento da campanha` : 'Os canais não possuem custo unitário'
    },
    underTextValueLeverage() {
      return this.isCostChannels ? `R$${localeString(this.metrics.analytic_metrics.general.price || 0, 0)}` : null
    },
  },

  watch: {
    'stateFilters.units': {
      async handler(value) {
        this.loadingFilter = true
        await this.getMetricsCampaignByUnits()
        await this.getOmniCampaignChannelsItems()
        await this.getOmniCampaignTicketsByHours()
        await this.getOmniCampaignTicketsByGenderAndAge()
        this.loadingPage = false
        this.loadingFilter = false
      },
    },
  },

  async mounted() {
    await this.getCampaign()
    this.$bus.$emit('filtrar')
  },

  destroyed() {
    this.RESET_MARIA_CAMPAIGN_MODULE()
  },

  methods: {
    getPeriod,
    getStatusLabel,
    floatToPercentString,
    putEmptyValue,
    criteriaGroup,
    campaignReceivedAndPurchasedAtUnitsOnFixedPeriodCriteria,

    ...mapMutations(['SET_MARIA_CAMPAIGN', 'RESET_MARIA_CAMPAIGN_MODULE']),

    backToOffersList() {
      this.$router.push({ name: 'Mar.ia Campaign' })
    },

    async cloneOmniCampaign() {
      const confirmed = await this.$confirm({
        ...this.$t('campanhas.confirmations.clone'),
        message: `Deseja duplicar ${this.campaign.name ? 'a campanha ' + this.campaign.name.trim().bold() : 'esta campanha'}?`,
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loadingCloneCampaign = true
      await this.$apollo
        .mutate({
          mutation: QUERY_CLONE_OMNI_CAMPAIGN,
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          variables: {
            id: this.campaign._id,
          },
        })
        .then((response) => {
          this.loadingCloneCampaign = false
          const id = response.data.cloneOmniCampaign._id
          this.$router.push({ name: 'Edit Mar.ia campaign', params: { id } })
        })
        .catch(() => {
          this.loadingCloneCampaign = false
          Swal.fire({
            text: 'Erro ao duplicar campanha',
            icon: 'error',
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              content: 'content-class',
            },
          })
        })
    },

    formatOfferSales(data) {
      let offerSales = []
      data.forEach((offer) => {
        if (['CampaignOfferSalesGroup', 'OfferSalesGroup'].includes(offer.__typename) || offer?.isGroup) {
          offerSales.push(
            ...offer.offer_sales.map((offerGroup) => {
              return {
                ...offerGroup,
                price_1: offer.price_1,
                price_2: offer.price_2,
                isGroup: true,
                nameGroup: offer.name,
                groupInfo: {
                  _id: offer._id,
                  __typename: 'ProductsGroup',
                },
              }
            })
          )
        } else offerSales.push(offer)
      })
      return offerSales
    },

    formatTakePayOfferSales(data) {
      let takepay = []
      data.forEach((offer) => {
        if (['CampaignOfferSalesTakeAndPayGroup', 'OfferSalesTakeAndPayGroup'].includes(offer.__typename)) {
          takepay.push(
            ...offer.takepay_offer_sales.map((offerGroup) => {
              return {
                ...offerGroup,
                take: offer.take,
                pay: offer.pay,
                isGroup: true,
                nameGroup: offer.name,
                groupInfo: {
                  _id: offer._id,
                  __typename: 'ProductsGroup',
                },
              }
            })
          )
        } else takepay.push(offer)
      })
      return takepay
    },

    formatPercentageOfferSales(data) {
      let percentage = []
      data.forEach((offer) => {
        if (['CampaignOfferSalesPercentageGroup', 'OfferSalesPercentageGroup'].includes(offer.__typename)) {
          percentage.push(
            ...offer.percentage_offer_sales.map((offerGroup) => {
              return {
                ...offerGroup,
                percentage_discount: offer.percentage_discount,
                isGroup: true,
                nameGroup: offer.name,
                groupInfo: {
                  _id: offer._id,
                  __typename: 'ProductsGroup',
                },
              }
            })
          )
        } else percentage.push(offer)
      })
      return percentage
    },

    formatComboOfferSales(data) {
      const comboOfferSalesProducts = assertArray(data).reduce((productList, product) => {
        productList.push(...mergeAllComboProducts(product.target_products, 'target_products'))
        productList.push(...mergeAllComboProducts(product.trigger_products, 'trigger_products'))

        return productList
      }, [])
      return comboOfferSalesProducts
    },

    async getCampaign() {
      this.loadingPage = true
      await this.$apollo
        .query({
          query: QUERY_GET_OMNI_CAMPAIGN,
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          variables: {
            id: this.$route.params.id,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { omniCampaign } }) => {
          this.campaign = {
            ...omniCampaign,
            offer_sales: this.formatOfferSales(omniCampaign.offer_sales),
            takepay_offer_sales: this.formatTakePayOfferSales(omniCampaign.takepay_offer_sales),
            percentage_offer_sales: this.formatPercentageOfferSales(omniCampaign.percentage_offer_sales),
            combo_offer_sales: this.formatComboOfferSales(omniCampaign.combo_offer_sales),
          }
          this.SET_MARIA_CAMPAIGN(this.campaign)
        })
        .catch((error) => {
          console.error(error)
          Swal.fire({
            text: 'Erro ao buscar campanha',
            icon: 'error',
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              content: 'content-class',
            },
          })
        })
    },

    async getMetricsCampaignByUnits() {
      await this.$apollo
        .query({
          query: QUERY_METRICS_OMNI_CAMPAIGN_BY_UNITS,
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          variables: {
            id: this.$route.params.id,
            units: this.stateFilters.units,
          },
          fetchPolicy: 'no-cache',
        })
        .then(
          ({
            data: {
              omniCampaign: { metrics, version },
            },
          }) => {
            this.metrics = metrics
            this.version = version ?? 1
          }
        )
        .catch((error) => {
          console.error(error)
          Swal.fire({
            text: 'Erro ao buscar campanha',
            icon: 'error',
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              content: 'content-class',
            },
          })
        })
    },

    async getOmniCampaignTicketsByHours() {
      await this.$apollo
        .query({
          query: QUERY_GET_OMNI_CAMPAIGN_TICKETS_BY_HOURS,
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          variables: {
            id: this.$route.params.id,
            units: this.stateFilters.units,
          },
          fetchPolicy: 'no-cache',
        })
        .then(
          ({
            data: {
              omniCampaignTicketsByHour: { metrics },
            },
          }) => {
            this.ticketsByHour = metrics
          }
        )
        .catch((error) => {
          console.error(error)
          Swal.fire({
            text: 'Erro ao buscar campanha',
            icon: 'error',
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              content: 'content-class',
            },
          })
        })
    },

    async getOmniCampaignTicketsByGenderAndAge() {
      await this.$apollo
        .query({
          query: QUERY_GET_OMNI_CAMPAIGN_TICKETS_BY_GENDER_AND_AGE,
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          variables: {
            id: this.$route.params.id,
            units: this.stateFilters.units,
          },
          fetchPolicy: 'no-cache',
        })
        .then(
          ({
            data: {
              omniCampaignAverageTicketByGenderAndAge: { metrics, totals },
            },
          }) => {
            this.ticketByGenderAndAge = { metrics, totals }
          }
        )
        .catch((error) => {
          console.error(error)
          Swal.fire({
            text: 'Erro ao buscar campanha',
            icon: 'error',
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              content: 'content-class',
            },
          })
        })
    },

    async getOmniCampaignChannelsItems() {
      await this.$apollo
        .query({
          query: QUERY_GET_OMNI_CAMPAIGN_CHANNELS_ITEMS,
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          variables: {
            id: this.$route.params.id,
            units: this.stateFilters.units,
          },
          fetchPolicy: 'no-cache',
        })
        .then(
          ({
            data: {
              omniCampaignAverageItemsByClientMessageReceiving: { metrics },
            },
          }) => {
            this.itemsBasket = metrics
          }
        )
        .catch((error) => {
          console.error(error)
          Swal.fire({
            text: 'Erro ao buscar campanha',
            icon: 'error',
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              content: 'content-class',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss">
.v-select__selection--comma {
  overflow: inherit !important;
}

.select-label {
  width: min-content;
  color: $marca-0-l40;
  display: inline-flex;
  cursor: pointer;
}

.table-card-title {
  font-family: 'Lato', sans-serif !important;
  font-style: normal;
  font-weight: normal !important;
  font-size: 18px !important;
  line-height: 120% !important;
  color: $cinza-d10 !important;
}

.subtitle {
  font-family: 'Lato', sans-serif !important;
  font-size: 16px !important;
  color: $cinza-0 !important;
  word-break: break-word !important;
}

.btn-link {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  text-decoration-line: underline;
  color: $marca-0-l40 !important;
}

.campaign-description {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.4px;
  color: $cinza-0;
}

.info-header {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 120%;
  color: $cinza-d10;
}

.info-description {
  font-family: Lato !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 14px !important;
  line-height: 150% !important;
  color: $cinza-0 !important;
}

.v-input--switch.v-input--is-dirty.v-input--is-disabled {
  opacity: 1;

  .v-input--selection-controls__input {
    opacity: 0.6 !important;
  }
}

.v-input--selection-controls {
  margin: 0 !important;
  padding: 0 !important;
  cursor: none !important;
}

.section-title {
  div {
    font-size: 25px !important;
    font-weight: 700 !important;
    line-height: 120% !important;
    letter-spacing: 0 !important;
    color: $marca-0-l40 !important;
  }
}
</style>
